import { render, staticRenderFns } from "./MansionSummary.vue?vue&type=template&id=2315f48a&scoped=true&"
import script from "./MansionSummary.vue?vue&type=script&lang=js&"
export * from "./MansionSummary.vue?vue&type=script&lang=js&"
import style0 from "./MansionSummary.vue?vue&type=style&index=0&id=2315f48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315f48a",
  null
  
)

export default component.exports